import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
export function AuthorsSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  return <section id="authors" ref={ref} className="py-16 md:py-24" data-id="element-31">
      <div className="max-w-4xl mx-auto px-6" data-id="element-32">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-center mb-14" data-id="element-33">
          <span className="inline-block px-4 py-1.5 text-xs font-semibold tracking-wider uppercase border rounded-full bg-teal-500/20 text-teal-400 border-teal-500/30" data-id="element-34">
            Your Guides Through the Game
          </span>
        </motion.div>

        {/* Authors grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-35">
          {/* Nicolás Pereira */}
          <motion.div initial={{
          opacity: 0,
          y: 24
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="p-6 md:p-8 rounded-2xl bg-neutral-900/50 border border-neutral-800/50" data-id="element-36">
            <div className="w-14 h-14 rounded-full bg-teal-500/15 flex items-center justify-center mb-5" data-id="element-37">
              <span className="text-teal-400 text-lg font-bold" data-id="element-38">NP</span>
            </div>
            <h3 className="font-serif text-xl text-white font-bold mb-1" data-id="element-39">
              Nicolás Pereira
            </h3>
            <p className="text-teal-400 text-sm font-medium mb-4" data-id="element-40">Researcher</p>
            <p className="text-neutral-400 text-sm leading-relaxed" data-id="element-41">
              Researcher of expanded states of consciousness and the hidden
              architecture of reality. Over a decade mapping the intersection
              between quantum science and ancient mystical systems.
            </p>
          </motion.div>

          {/* Gabriel Beltrán */}
          <motion.div initial={{
          opacity: 0,
          y: 24
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="p-6 md:p-8 rounded-2xl bg-neutral-900/50 border border-neutral-800/50" data-id="element-42">
            <div className="w-14 h-14 rounded-full bg-teal-500/15 flex items-center justify-center mb-5" data-id="element-43">
              <span className="text-teal-400 text-lg font-bold" data-id="element-44">GB</span>
            </div>
            <h3 className="font-serif text-xl text-white font-bold mb-1" data-id="element-45">
              Gabriel Beltrán
            </h3>
            <p className="text-teal-400 text-sm font-medium mb-4" data-id="element-46">
              Facilitator
            </p>
            <p className="text-neutral-400 text-sm leading-relaxed" data-id="element-47">
              Bridge between ancient wisdom and modern understanding. His direct
              experience with expanded consciousness traditions allows him to
              translate the ineffable into words that transform.
            </p>
          </motion.div>
        </div>

        {/* Author quote */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="text-center py-8 px-6 rounded-2xl bg-gradient-to-r from-teal-500/5 via-teal-500/10 to-teal-500/5 border border-teal-500/10" data-id="element-48">
          <p className="font-serif text-xl md:text-2xl text-white italic leading-relaxed" data-id="element-49">
            "Written from direct experience — not theory."
          </p>
        </motion.div>
      </div>
    </section>;
}